var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.299 1.45117H10.799C9.25194 1.45117 7.7682 2.06575 6.67424 3.15972C5.58028 4.25368 4.9657 5.73741 4.9657 7.28451V10.7845H1.4657V15.4512H4.9657V24.7845H9.63236V15.4512H13.1324L14.299 10.7845H9.63236V7.28451C9.63236 6.97509 9.75528 6.67834 9.97407 6.45955C10.1929 6.24076 10.4896 6.11784 10.799 6.11784H14.299V1.45117Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bb70ab55e261359d83c08eb68d2b4d36.svg";
export { ForwardRef as ReactComponent };